<div class="flex flex-col gap-10">
  <app-info-message
    [label]="
      'Podgląd danych identyfikacyjnych. Dane aktualizowane są automatycznie danymi dostarczonymi z obsługiwanych obszarów (np. Rejestr żłobków).'
    "
  />
  <p-card header="Dane podmiotu" tabindex="0" class="custom-card">
    <app-preview-organization-subject
      [identyfikator]="organization()?.idZlobki"
    ></app-preview-organization-subject>
  </p-card>
  <p-card header="Dane identyfikujące" tabindex="0" class="custom-card">
    <app-preview-organization-details
      [organization]="organization()"
    ></app-preview-organization-details>
  </p-card>
  <p-card header="Dane kontaktowe" tabindex="0" class="custom-card">
    <app-preview-contact [organization]="organization()"></app-preview-contact>
  </p-card>
  <p-card header="Adres siedziby podmiotu" tabindex="0" class="custom-card">
    <app-preview-address
      [address]="organization()?.adres"
    ></app-preview-address>
  </p-card>
  <p-card
    header="Numer rachunku bankowego podmiotu prowadzącego żłobek, klub dziecięcy, zatrudniającego dziennego opiekuna lub dziennego opiekuna prowadzącego działalność na własny rachunek"
    tabindex="0"
    class="custom-card"
  >
    <app-preview-organization-account-number
      [organization]="organization()"
    ></app-preview-organization-account-number>
  </p-card>
</div>
